// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 클린 스타일 - 배경색 및 밑줄 제거 */
.clean-container {
  padding: 20px;
  width: 100%;
  font-family: sans-serif;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.company-title {
  font-size: 36px;
  font-weight: bold;
  margin: 0;
}

.edit-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 210px;
  height: 50px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-text {
  margin-left: 8px;
}

.clean-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 30px 0;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 30px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 30px;
}

.info-list {
  width: 100%;
}

.info-row {
  display: flex;
  margin-bottom: 25px;
  align-items: center;
  border: none; /* 테두리 명시적으로 제거 */
}

.info-label {
  width: 150px;
  margin-right: 50px;
  font-size: 24px;
  font-weight: bold;
  background-color: transparent; /* 배경색 명시적으로 제거 */
  border: none; /* 테두리 명시적으로 제거 */
}

.info-value {
  font-size: 20px;
  background-color: transparent; /* 배경색 명시적으로 제거 */
  border: none; /* 테두리 명시적으로 제거 */
}

.loading, .errorMessage {
  padding: 20px;
  text-align: center;
  color: #666;
}

.edit-buttons {
  display: flex;
  gap: 10px;
}

.delete-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ff0000;
  color: #ff0000;
  border-radius: 4px;
  width: 120px;
  height: 50px;
  font-size: 16px;
  cursor: pointer;
}

.save-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  width: 120px;
  height: 50px;
  font-size: 16px;
  cursor: pointer;
}

.edit-input {
  padding: 8px 12px;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 250px;
  height: 40px;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.delete-button, .save-button, .edit-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 210px;
  height: 50px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.delete-button svg, .save-button svg, .edit-button svg {
  display: block;
  min-width: 24px;
}

.delete-button {
  color: #000;
}

.save-button {
  color: #000;
}

.button-text {
  margin-left: 10px;
}

.edit-input {
  padding: 8px 12px;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 250px;
  height: 40px;
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminCompanyDetail.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B,EAAE,iBAAiB;EAChD,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,eAAe;EACf,6BAA6B,EAAE,iBAAiB;EAChD,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd","sourcesContent":["/* 클린 스타일 - 배경색 및 밑줄 제거 */\n.clean-container {\n  padding: 20px;\n  width: 100%;\n  font-family: sans-serif;\n}\n\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.company-title {\n  font-size: 36px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.edit-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 210px;\n  height: 50px;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.button-text {\n  margin-left: 8px;\n}\n\n.clean-divider {\n  height: 1px;\n  background-color: #e0e0e0;\n  margin: 30px 0;\n}\n\n.content-section {\n  margin-bottom: 30px;\n}\n\n.section-title {\n  font-size: 30px;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 30px;\n}\n\n.info-list {\n  width: 100%;\n}\n\n.info-row {\n  display: flex;\n  margin-bottom: 25px;\n  align-items: center;\n  border: none; /* 테두리 명시적으로 제거 */\n}\n\n.info-label {\n  width: 150px;\n  margin-right: 50px;\n  font-size: 24px;\n  font-weight: bold;\n  background-color: transparent; /* 배경색 명시적으로 제거 */\n  border: none; /* 테두리 명시적으로 제거 */\n}\n\n.info-value {\n  font-size: 20px;\n  background-color: transparent; /* 배경색 명시적으로 제거 */\n  border: none; /* 테두리 명시적으로 제거 */\n}\n\n.loading, .errorMessage {\n  padding: 20px;\n  text-align: center;\n  color: #666;\n}\n\n.edit-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.delete-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #ff0000;\n  color: #ff0000;\n  border-radius: 4px;\n  width: 120px;\n  height: 50px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.save-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 120px;\n  height: 50px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.edit-input {\n  padding: 8px 12px;\n  font-size: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 250px;\n  height: 40px;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 15px;\n}\n\n.delete-button, .save-button, .edit-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 210px;\n  height: 50px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  border: 1px solid #ccc;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.delete-button svg, .save-button svg, .edit-button svg {\n  display: block;\n  min-width: 24px;\n}\n\n.delete-button {\n  color: #000;\n}\n\n.save-button {\n  color: #000;\n}\n\n.button-text {\n  margin-left: 10px;\n}\n\n.edit-input {\n  padding: 8px 12px;\n  font-size: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 250px;\n  height: 40px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
